import { GroupedErrors, LoansErrorHookProps, SeverityCode, SeverityCodes } from '../types';

export const getSeverityPrefix = (compositeCode: string): string => compositeCode.split(':')[0];

const validSeverityCodes: SeverityCode[] = [
  SeverityCodes.requiresReview,
  SeverityCodes.warning,
  SeverityCodes.error,
  SeverityCodes.info
];

export function isValidSeverityKey(value: string): value is SeverityCode {
  return validSeverityCodes.includes(value as SeverityCode);
}

export const groupErrorsBySeverity = (
  mappedCodes: Record<string, LoansErrorHookProps>
): GroupedErrors => {
  const groupedErrors: GroupedErrors = {};
  const sortedEntries = Object.entries(mappedCodes).sort(
    (a, b) => Number(a[1].errorMessageDescriptionID) - Number(b[1].errorMessageDescriptionID)
  );
  sortedEntries.forEach(([code, errorObj]) => {
    const severityKey = getSeverityPrefix(code);
    if (!isValidSeverityKey(severityKey)) return;
    if (!groupedErrors[severityKey]) groupedErrors[severityKey] = {};
    groupedErrors[severityKey]![code] = errorObj;
  });

  return groupedErrors;
};

export const sortSeverityKeys = (
  severityKeys: SeverityCode[],
  severityMapping: Record<string, string>
): SeverityCode[] => {
  return severityKeys.sort((a, b) => {
    const severityOrderA = Object.keys(severityMapping).indexOf(a);
    const severityOrderB = Object.keys(severityMapping).indexOf(b);
    return severityOrderA - severityOrderB;
  });
};
